export const DEPLOYMENT_KEY_MIN_LENGTH = 10;
export const DEPLOYMENT_KEY_MAX_LENGTH = 100;
export const DEPLOYMENT_KEY_PATTERN = /^[a-zA-Z0-9_-]+$/;

export type DeploymentKeyIssue = "length" | "charset";

export function validateDeploymentKey(value: string): DeploymentKeyIssue | null {
  const key = value.trim();
  if (!key) return null;
  if (key.length < DEPLOYMENT_KEY_MIN_LENGTH || key.length > DEPLOYMENT_KEY_MAX_LENGTH) {
    return "length";
  }
  return DEPLOYMENT_KEY_PATTERN.test(key) ? null : "charset";
}
